// extracted by mini-css-extract-plugin
export default {"headerContainer":"Wallet_headerContainer__-m8rs","container":"Wallet_container__mnbqk","logo":"Wallet_logo__hJjFl","button":"Wallet_button__sQoHD","title":"Wallet_title__h+Uck"};